import * as _ from 'underscore';

angular.module('vastdesk').
  component('daypartingSelect', {
    bindings: {
      dayParting: '=',
    },
    template: require('../templates/daypartingSelect.html'),
    controllerAs: '$daypartingSelectCtrl',
    controller: ['$scope', '$timeout', '$element', function($scope, $timeout, $element) {
      const self = this;

      /** @type {{name: string, position: number}[]} */
      this.days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat']
          .map((name, position) => ({name, position}));

      /** @type {{name: string, position: number}[]} */
      this.hours = [
        '12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am',
        '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm']
          .map((name, position) => ({name, position}));

      this.isSelected = function(day, hour) {
        if (!Array.isArray(self.dayParting) || self.dayParting.length < 1) {
          return false;
        }
        return self.dayParting[day][hour];
      };

      //
      // click and drag selection
      //

      let isMouseDown = false;
      let startCoords = null;
      let endCoords = null;
      let startCellSelected = false;

      const resetPendingDayParts = function() {
        $element.find('td.daypart-selectable')
                .removeClass('daypart-pending-selected')
                .removeClass('daypart-pending-deselected');
      };

      const setPendingDayPart = function(day, hour, value) {
        const td = $element.find('td[data-coordinates="' + day + '-' + hour + '"]');
        td.toggleClass('daypart-pending-selected', value);
        td.toggleClass('daypart-pending-deselected', !value);
      };

      const setDayPart = function(day, hour, value) {
        self.dayParting[day][hour] = value;
      };

      const editCells = function(startCoords, endCoords, cb, startCellSelected) {
        const minDay = _.min([startCoords[0], endCoords[0]]);
        const maxDay = _.max([startCoords[0], endCoords[0]]);
        const minHour = _.min([startCoords[1], endCoords[1]]);
        const maxHour = _.max([startCoords[1], endCoords[1]]);

        for(let i = minDay; i <= maxDay; i++) {
          for(let j = minHour; j <= maxHour; j++) {
            cb(i, j, !startCellSelected);
          }
        }
      };

      /**
       * @param coords {[number, number]}
       * @param isSelected {boolean}
       * @returns {boolean}
       */
      this.handleMouseDown = function (coords, isSelected) {
        isMouseDown = true;
        startCoords = coords;
        endCoords = coords;
        startCellSelected = isSelected;
        editCells(startCoords, endCoords, setPendingDayPart, startCellSelected);
        return false; // prevent text selection
      };

      /**
       * @param coords {[number, number]}
       */
      this.handleMouseOver = function (coords) {
        if (isMouseDown) {
          resetPendingDayParts();
          endCoords = coords;
          editCells(startCoords, endCoords, setPendingDayPart, startCellSelected);
        }
      };

      this.handleMouseLeave = function () {
        resetPendingDayParts();
      };

      this.handleMouseUp = function () {
        editCells(startCoords, endCoords, setDayPart, startCellSelected);
        resetPendingDayParts();
      };

      this.$onInit = function () {
        $element.find('td.daypart-selectable')
            .on('selectstart', function () {
              return false;
            });

        $(document).mouseup(function () {
          isMouseDown = false;
        });
      };
    }]
  });
